import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@progress/kendo-react-dialogs';
import { GovoLoading } from '../../../assets/logos';
import '@progress/kendo-theme-default/dist/all.css';
import './dialogSystemGL.css';
import { ButtonHLPure, LabelModalPure } from '..'

/**
 * @typedef {object} Props
 * @property {boolean} [showLoadingRequesting] State to show loading
 * @property {boolean} [showCompletedRequesting] State to show completed
 * @property {boolean} [showErrorRequesting] State to show error
 * @property {boolean} [showWarningRequesting] State to show warning
 * @property {boolean} [isWarnign] State to show warning extra
 * @property {(event: import('@progress/kendo-react-dialogs').DialogCloseEvent | React.MouseEvent<HTMLButtonElement, MouseEvent>) => void} [toggleLoadingRequesting] Function to toggle loading state
 * @property {(event: import('@progress/kendo-react-dialogs').DialogCloseEvent | React.MouseEvent<HTMLButtonElement, MouseEvent>) => void} [toggleCompletedRequesting] Function to toggle loading state
 * @property {(event: import('@progress/kendo-react-dialogs').DialogCloseEvent | React.MouseEvent<HTMLButtonElement, MouseEvent>) => void} [toggleErrorRequesting] Function to toggle error state
 * @property {(event: import('@progress/kendo-react-dialogs').DialogCloseEvent | React.MouseEvent<HTMLButtonElement, MouseEvent>) => void} [toggleWarningRequesting] Function to toggle warning state
 * @property {string} [message] Message in the dialog
 * @property {string} [messageError] Error message in the dialog
 * @property {string} [messageComplete] Completed message in the dialog
 * @property {string} [messageWarning] Warning message in the dialog
 * @property {(event: import('@progress/kendo-react-dialogs').DialogCloseEvent | React.MouseEvent<HTMLButtonElement, MouseEvent>) => void} [handleWarning] Function to toggle warning dialog
 * @property {boolean} [showButton] State to show or not a button in the right bottom
 * @property {string} [messageButton] (in almost all the cases is a 'Aceptar' or 'Accept' text)
 * @property {string} [wrapTextClass] Class to wrap text
 * 
 * @property {boolean} [showConfirm] Show the new confirmation modal
 * @property {string} [confirmTitle] Title for the confirmation modal
 * @property {string} [confirmMessage] Message for the confirmation modal
 * @property {string} [confirmDeleteFlowIconUrl] Optional icon url for the confirmation modal (defaults to warning icon)
 * @property {() => void} [handleConfirmDeleteFlowClose] Close/cancel handler for the confirmation modal
 * @property {() => void} [handleConfirmDeleteFlowSubmit] Submit/accept handler for the confirmation modal
 * @property {string} [labelCancelConfirmation] Label for cancel button in confirmation modal
 * @property {string} [labelSubmitConfirmation] Label for submit button in confirmation modal
 * @property {React.ReactNode} [confirmChildren] Optional extra content for confirmation modal (contextual details)
 * @property {boolean} [isJustified] - Si es true, el texto del mensaje se muestra justificado
 * 
 * @property {boolean} [showInfoRequesting] Show the new information modal
 * @property {string} [infoTitle] Title for info modal
 * @property {string} [infoMessage] Message for info modal
 * @property {string} [labelInfoBtn] Label for button in info modal
 * @property {() => void} [handleInfoClose] Close/submit handler for info modal
 */

/* === Custom component title for dialog loading === */
const CustomLoadingTitleBar = () => {
  return (
    <div className='dialogSystemGLPure-customTitleBarStyles'>
      {/* <span>{t('dialogSystemGLPure.titleDialogSignRequest')}</span> */}
    </div>
  )
}

/* === Custom component title for dialog complete === */
const CustomCompleteTitleBar = (props) => {
  const { title } = props
  const { t } = useTranslation()
  return (
    <div className='dialogSystemGLPure-customTitleBarStyles'>
      <span>{title || t('dialogSystemGLPure.titleDialogSignRequest')}</span>
    </div>
  )
}

/* === Custom component title for dialog error === */
const CustomErrorTitleBar = (props) => {
  const { title } = props
  const { t } = useTranslation()
  return (
    <div className='dialogSystemGLPure-customTitleBarStyles'>
      <span>{title || t('dialogSystemGLPure.titleDialogSignRequest')}</span>
    </div>
  )
}

/**
 * @param {Props} props
      */
const DialogSystemGLPure = (props) => {
  const {
    showLoadingRequesting, //State for loading dialog
    showCompletedRequesting, //State for complete dialog
    showErrorRequesting, //State for error dialog
    showWarningRequesting, //State for warning dialog
    isWarnign, //State for other warning dialog
    toggleLoadingRequesting, //Function to change state for loading dialog
    toggleCompletedRequesting, //Function to change state for complete dialog
    toggleErrorRequesting, //Function to change state for error dialog
    toggleWarningRequesting = () => { }, //Function to change state for warning dialog
    message, //Text message to error, warning, completed
    messageError,//Text message to error,
    messageComplete,// //Text message to completed,
    messageWarning, //Text message to warning
    showButton,
    messageButton,
    wrapTextClass,
    showBtnCancelWarning,
    showBtnSubmitWarning,
    handleWarningClose,
    handleWarningSubmit,
    labelWarningBtnSubmit,
    labelWarningBtnCancel,
    heightDialog,
    widthDialog,
    titleDialog,
    showConfirm,
    confirmTitle,
    confirmMessage,
    handleConfirmDeleteFlowClose,
    handleConfirmDeleteFlowSubmit,
    labelCancelConfirmation,
    labelSubmitConfirmation,
    confirmChildren,
    showInfoRequesting,
    infoTitle,
    infoMessage,
    labelInfoBtn,
    handleInfoClose,
    isJustified
  } = props
  const { t } = useTranslation()
  const ENV = process.env

  return (
    <>
      {/* === DIALOG LOADIGN === */}
      {showLoadingRequesting && (
        <Dialog
          // width={widthLoading}
          // height={heightLoading}
          className={'dialogSystemGLPure-loading'}
          onClose={() => toggleLoadingRequesting()}
          title={<CustomLoadingTitleBar />}
        >
          {/**Loading icon**/}
          <div className='dialogSystemGLPure-containerIcon'>
            <img
              alt=''
              src={GovoLoading}
              className='dialogSystemGLPure-imgNotification'
            ></img>
          </div>
          {/**Loading text**/}
          <div className='dialogSystemGLPure-textLoading'>
            <p className='dialogSystemGLPure-text'>
              {t('dialogSystemGLPure.titleExecutingRequest')}
            </p>
            <p className='dialogSystemGLPure-text'>{t('dialogSystemGLPure.subtitleExecutingRequest')}</p>
          </div>
        </Dialog>
      )}

      {/* === DIALOG SUCCESSFUL === */}
      {showCompletedRequesting && (
        <Dialog
          className='dialogSystemHLPure-success'
          title={<CustomCompleteTitleBar title={titleDialog} />}
          onClose={() => toggleCompletedRequesting()}
        >
          <div className='dialogSystemHLPure-containerIcon'>
            <img alt='' src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICON_MODAL_SUCCESS}`} width={48} height={48} />
          </div>
          <div>
            {wrapTextClass ?
              <div className={wrapTextClass}>
                <p className='dialogSystemHLPure-text'>
                  {messageComplete && messageComplete.trim() !== '' ? messageComplete : t('dialogSystemGLPure.requestSucces')}
                </p>
              </div>
              :
              <p className='dialogSystemHLPure-text'>
                {messageComplete && messageComplete.trim() !== '' ? messageComplete : t('dialogSystemGLPure.requestSucces')}
              </p>
            }
          </div>
          {showButton && (
            <div className='dialogSystemHLPure-containerIcon'>
              <ButtonHLPure
                nameBtn={messageButton ? messageButton : 'Aceptar'}
                primary={true}
                onClickBtn={() => toggleCompletedRequesting()}
              />
            </div>)}
        </Dialog>
      )
      }

      {/* === DIALOG ERROR === */}
      {
        showErrorRequesting && (
          <Dialog
            className='DialogSystemHL-hide-scroll'
            title={<CustomErrorTitleBar title={titleDialog} />}
            onClose={() => toggleErrorRequesting()}
            width={290}
          // height={340}
          >
            <div className='dialogSystemHLPure-containerIcon'>
              <img alt='' src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICON_MODAL_ERROR}`} width={48} height={48} />
            </div>
            {message || messageError ? (
              <p className='dialogSystemHLPure-text'>{message ? message : messageError}</p>
            ) : (
              <p className='dialogSystemHLPure-text'>
                {t('dialogSystemGLPure.anErrorOcurredInTheRequesting')}
              </p>
            )}
          </Dialog>
        )
      }
      {/* === DIALOG WARNING === */}
      {
        showWarningRequesting && (
          <Dialog
            title={<CustomErrorTitleBar />}
            onClose={() => toggleWarningRequesting()}
            width={290}
          >
            <div className='dialogSystemHLPure-containerIcon'>
              <img alt='' src={`${ENV.REACT_APP_ROUTE_BUCKET_AWS}${ENV.REACT_APP_ICON_MODAL_WARNING}`} />
            </div >
            {message || messageWarning ? (
              <p className='dialogSystemHLPure-text'>{message ? message : messageWarning}</p>
            ) : (
              <p className='dialogSystemGLPure-text'>
                {t('dialogSystemGLPure.anErrorOcurredInTheRequesting')}
              </p>
            )}
            {
              showButton && (
                <div className='dialogSystemHLPure-containerButton'>
                  <ButtonHLPure
                    nameBtn={messageButton ? messageButton : 'Aceptar'}
                    primary={false}
                    onClickBtn={() => toggleWarningRequesting()}
                  />
                </div>)
            }
          </Dialog >
        )
      }

      {/* === DIALOG CONFIRM === */}
      {
        showConfirm && (
          <Dialog
            className='dialogSystemHLPure-confirm'
            title={<CustomErrorTitleBar title={confirmTitle || titleDialog} />}
            onClose={() => handleConfirmDeleteFlowClose()}
            width={420}
          >
            <div className='dialogSystemHLPure-confirm-container'>
              <div className='dialogSystemHLPure-confirm-icon-container'>
                <img alt='' className='dialogSystemHLPure-confirm-icon' src={`${ENV.REACT_APP_ROUTE_BUCKET_AWS}${ENV.REACT_APP_ICON_MODAL_CONFIRMATION}`} />
              </div>
              <div className='dialogSystemHLPure-confirm-content'>
                <p
                  className={`dialogSystemHLPure-confirm-message ${isJustified
                    ? 'dialogSystemHLPure-confirm-message-justified'
                    : 'dialogSystemHLPure-confirm-message-centered'
                    }`}
                >
                  {confirmMessage || t('dialogSystemGLPure.confirmDeleteFlow.message')}
                </p>

                {confirmChildren && (
                  <div className='dialogSystemHLPure-confirm-details'>
                    {confirmChildren}
                  </div>
                )}
              </div>
              <div className='dialogSystemHLPure-confirm-btns'>
                <ButtonHLPure
                  nameBtn={labelCancelConfirmation || t('button.cancel')}
                  onClickBtn={handleConfirmDeleteFlowClose}
                  primary={false}
                />
                <ButtonHLPure
                  nameBtn={labelSubmitConfirmation || t('dialogSystemGLPure.confirmDeleteFlow.submit')}
                  onClickBtn={handleConfirmDeleteFlowSubmit}
                  primary={true}
                />
              </div>
            </div>
          </Dialog>
        )
      }

      {/* === DIALOG INFORMATION === */}
      {
        showInfoRequesting && (
          <Dialog
            className='dialogSystemHLPure-information'
            title={<CustomErrorTitleBar title={infoTitle || titleDialog} />}
            onClose={handleInfoClose}
            width={400}
            height={250}
          >
            <div className='dialogSystemHLPure-warning-container'>
              <div className='dialogSystemHLPure-warning-container-items'>
                <img
                  alt=''
                  className='dialogSystemHLPure-warning-icon'
                  src={`${process.env.REACT_APP_ROUTE_BUCKET_AWS}${process.env.REACT_APP_ICON_MODAL_INFORMATION}`}
                />
                <LabelModalPure label={infoMessage || t('dialogSystemGLPure.information.defaultMessage')} />
              </div>
              <div className='dialogSystemHLPure-warning-btns'>
                <ButtonHLPure
                  nameBtn={labelInfoBtn || t('button.accept')}
                  onClickBtn={handleInfoClose}
                  primary={true}
                />
              </div>
            </div>
          </Dialog>
        )
      }


      {
        isWarnign && (
          <Dialog
            className=''
            title={<CustomErrorTitleBar title={titleDialog} />}
            onClose={handleWarningClose}
            width={widthDialog || 290}
            height={heightDialog || 340}
          >
            <div className='dialogSystemHLPure-warning-container'>
              <div className='dialogSystemHLPure-warning-container-items'>
                <img alt='' className='dialogSystemHLPure-warning-icon' src={`${ENV.REACT_APP_ROUTE_BUCKET_AWS}${ENV.REACT_APP_ICON_MODAL_WARNING}`} />
                <LabelModalPure label={messageWarning ? messageWarning : message ? message : t('dialogSystemGLPure.anErrorOcurredInTheRequesting')} />
              </div>
              <div className='dialogSystemHLPure-warning-btns'>
                {
                  showBtnCancelWarning && (
                    <ButtonHLPure
                      nameBtn={labelWarningBtnCancel || t('button.return')}
                      onClickBtn={() => handleWarningClose()}
                      primary={false}
                    />
                  )
                }
                {
                  showBtnSubmitWarning && (
                    <ButtonHLPure
                      nameBtn={labelWarningBtnSubmit || t('button.accept')}
                      onClickBtn={() => handleWarningSubmit()}
                      primary={true}
                    />
                  )
                }
              </div>
            </div>
          </Dialog>
        )
      }
    </>
  )
}

export default DialogSystemGLPure